import { BookingTreeActionType } from "models/actionTypes/bookingTreeActionTypes";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { BookingTreeState } from "models/stateTypes/bookingTreeState";
import { ReduxConstants } from "utils/constants";

const initialState: BookingTreeState = {
  bookingTipSuggestions: {},
  bookingTreeItems: [],
};

export const bookingTreeReducer = (
  state: BookingTreeState = initialState,
  action: BookingTreeActionType | RootActionType
): BookingTreeState => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
    case ReduxConstants.BookingTreeActions.RESET_BOOKING_TREE_STATE:
      return initialState;
    case ReduxConstants.BookingTreeActions.ADD_BOOKING_TIP_SUGGESTION:
      return {
        ...state,
        bookingTipSuggestions: {
          ...state.bookingTipSuggestions,
          [action.payload.invoiceId]: [...action.payload.suggestions],
        },
      };
    case ReduxConstants.BookingTreeActions.SET_BOOKING_TREE_ITEMS:
      return {
        ...state,
        bookingTreeItems: action.payload,
      };
    default:
      return state;
  }
};
